import React from 'react';
import { Box, Typography, Container, Link } from '@mui/material';

const UpcomingEventsSection = () => {
  const events = [
    // {
    //   date: "June 28th",
    //   venue: "Mt Shasta Hotel & Lodge",
    //   description: "spoken word w/ organik orchestra, 9pm",
    //   location: "Mt Shasta, CA"
    // },
    // {
    //   date: "July 4th",
    //   venue: "Studio Recording Session",
    //   description: "dub roots w/ true love nation, 10pm",
    //   location: "Mt Shasta, CA"
    // },
    // {
    //   date: "July 5th",
    //   venue: "Mixtape Recording Session",
    //   description: "hot pursuit vol. 1 (coming july 23rd)",
    //   location: "Mt Shasta, CA"
    // },
    // {
    //   date: "July 6th",
    //   venue: "Album Recording Session",
    //   description: "bright side (coming november 2nd)",
    //   location: "Mt Shasta, CA"
    // },
    // {
    //   date: "July 8th",
    //   venue: "Silk Road Chai Shop",
    //   description: "spoken word w/ bingi drumming, 6pm",
    //   location: "Mt Shasta, CA"
    // },
    // {
    //   date: "July 11th",
    //   venue: "Mt Shasta Vets Club",
    //   description: "spoken word w/ organik orchestra, 8pm",
    //   location: "Mt Shasta, CA"
    // }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      {/* Decorative Border Container with African Pattern */}
      <Box 
        sx={{ 
          position: 'relative',
          p: { xs: 2, md: 4 },
          backgroundImage: 'url(/images/african-border.png)',
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          border: '20px solid transparent',
          borderImage: 'url(/images/african-border.png) 50 stretch'
        }}
      >
        {/* Inner content area */}
        <Box 
          sx={{ 
            position: 'relative',
            bgcolor: 'rgba(0, 0, 0, 0.9)',
            p: { xs: 4, md: 8 },
            mx: { xs: 1, md: 2 },
            boxShadow: 'inset 0 0 0 2px rgba(218, 165, 32, 0.3)',
            color: 'white'
          }}
        >
          {/* Top Logo */}
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Box sx={{ 
              display: 'inline-block',
              bgcolor: 'black',
              borderRadius: '50%',
              p: 2,
              mb: 3
            }}>
              <Box
                component="img"
                src="/images/FreetimeRadioLogo.png"
                alt="Freedom Hour Radio"
                sx={{ height: 144, width: 'auto' }}
              />
            </Box>
            
            <Typography 
              variant="overline" 
              sx={{ 
                color: '#d4af37',
                fontSize: '0.875rem',
                fontWeight: 600,
                letterSpacing: 3,
                display: 'block',
                mb: 1
              }}
            >
              FREEDOM HOUR RADIO presents
            </Typography>

            <Box sx={{ 
              display: 'inline-block',
              bgcolor: 'black',
              borderRadius: '50%',
              p: 2,
              mb: 3
            }}>
              <Box
                component="img"
                src="/images/Akwerian-Dub-Logo.png"
                alt="Akwerius Dub"
                sx={{
                  width: {
                    xs: '80%',     // mobile — scale down
                    sm: '280px',   // small tablets
                    md: 'auto'     // default size for desktop
                  },
                  maxHeight: {
                    xs: '280px',    // mobile cap
                    sm: '320px',
                    md: '411px'     // original size
                  },
                  height: 'auto',
                  mx: 'auto',
                  display: 'block'
                }}
              />           
            </Box>            
            
            <Typography 
              variant="h2" 
              sx={{ 
                fontFamily: 'Georgia, serif',
                letterSpacing: 2,
                fontWeight: 'bold',
                mb: 3,
                fontSize: { xs: '2.5rem', md: '4rem' },
                color: 'white'
              }}
            >
              Akwerius Dub
            </Typography>

                        <Typography sx={{ color: '#fbbf24', mb: 1 }}>
              featuring
            </Typography> 

            <Typography sx={{ color: '#fcd34d', fontSize: '1.875rem', mb: 0.5 }}>
              poets, singers and players
            </Typography>
            <Typography sx={{ color: '#fcd34d', fontSize: '1.875rem', fontStyle: 'italic', mb: 0.5 }}>
             of the <Box component="em" sx={{ fontStyle: 'italic' }}>Music Is Healing Collective</Box>
            </Typography>
            {/* <Typography sx={{ color: '#fcd34d', fontSize: '0.875rem' }}>
              & host of the <Box component="strong" sx={{ fontWeight: 'bold' }}>Freedom Hour Radio Show</Box>
            </Typography> */}
          </Box>

          {/* Silhouette decorations */}
          {/* <Box sx={{ 
            display: { xs: 'none', md: 'flex' },
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 6,
            px: 8
          }}>
            <Box sx={{ 
              width: 96,
              height: 96,
              borderRadius: '50%',
              bgcolor: '#d97706',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '3rem'
            }}>
              🎤
            </Box>
            <Box sx={{ 
              width: 96,
              height: 96,
              borderRadius: '50%',
              bgcolor: '#d97706',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '3rem'
            }}>
              🎤
            </Box>
          </Box> */}

          {/* Events List */}
          <Box sx={{ mb: 6 }}>
            {events.map((event, index) => (
              <Typography 
                key={index}
                component="div"
                sx={{ 
                  textAlign: 'left',
                  lineHeight: 1.8,
                  mb: 1.5,
                  fontSize: { xs: '1.25rem', md: '1.5rem' }
                }}
              >
                <Box component="span" sx={{ color: '#fbbf24', fontWeight: 'bold' }}>
                  {event.date}
                </Box>
                {" – "}
                <Box component="span" sx={{ color: 'white', fontWeight: 600 }}>
                  {event.venue}:
                </Box>
                {" "}
                <Box component="span" sx={{ color: '#d1d5db' }}>
                  {event.description}
                </Box>
                {event.location && (
                  <>
                    {", "}
                    <Box component="span" sx={{ color: '#fcd34d' }}>
                      {event.location}
                    </Box>
                  </>
                )}
              </Typography>
            ))}
          </Box>

          {/* Footer Links */}
          {/* <Box sx={{ 
            mt: 8,
            pt: 6,
            borderTop: '1px solid rgba(217, 119, 6, 0.3)'
          }}>
            <Box sx={{ 
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
              gap: 3,
              fontSize: '1.25rem'
            }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Link 
                  href="https://www.akwerius.com"
                  target="_blank"
                  rel="noreferrer"
                  sx={{ 
                    color: '#fbbf24',
                    textDecoration: 'none',
                    '&:hover': { color: '#fcd34d' }
                  }}
                >
                  www.akwerius.com – music
                </Link>
                <Link 
                  href="https://www.wordsoundlife.org"
                  target="_blank"
                  rel="noreferrer"
                  sx={{ 
                    color: '#fbbf24',
                    textDecoration: 'none',
                    '&:hover': { color: '#fcd34d' }
                  }}
                >
                  www.wordsoundlife.org – organization
                </Link>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Link 
                  href="http://musicishealing.us"
                  target="_blank"
                  rel="noreferrer"
                  sx={{ 
                    color: '#fbbf24',
                    textDecoration: 'none',
                    '&:hover': { color: '#fcd34d' }
                  }}
                >
                  www.musicishealing.us – blog
                </Link>
                <Link 
                  href="mailto:afrorootshop@gmail.com"
                  sx={{ 
                    color: '#fbbf24',
                    textDecoration: 'none',
                    '&:hover': { color: '#fcd34d' }
                  }}
                >
                  contact - afrorootshop@gmail.com
                </Link>
              </Box>
            </Box>
          </Box> */}

          {/* Bottom Logos */}
          <Box sx={{ 
            mt: 6,
            display: 'flex',
            justifyContent: 'center',
            gap: 3,
            flexWrap: 'wrap'
          }}>
            <Box sx={{ bgcolor: 'black', borderRadius: 1, p: 1 }}>
              <Box
                component="img"
                src="/images/wsl-logo-trans.png"
                alt="Word Sound Life"
                sx={{ height: 77, width: 'auto' }}
              />
            </Box>
            <Box sx={{ bgcolor: 'black', borderRadius: 1, p: 1 }}>
              <Box
                component="img"
                src="/images/mihu-logo-trans.png"
                alt="Word Sound Life"
                sx={{ height: 77, width: 'auto' }}
              />
            </Box>
            <Box sx={{ 
              // background: 'linear-gradient(to bottom right, #f97316, #dc2626, #fbbf24)',
              bgcolor: 'black',
              borderRadius: 1,
              p: 2,
              minWidth: 60
            }}>
              <Box sx={{ 
                color: 'white',
                fontWeight: 'bold',
                textAlign: 'center'
              }}>
              <Box
                component="img"
                src="/images/afrorootshop-logo.png"
                alt="Afro Roots Hop"
                sx={{ height: 77, width: 'auto' }}
              />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default UpcomingEventsSection;

// import React from "react";
// import moment from "moment";
// import {
//   Box,
//   Container,
//   Typography,
//   Grid,
//   Button,
// } from "@mui/material";

// export default function UpcomingEvents({}) {
//   return (
//     // <Box
//     //   sx={{
//     //     py: 8,
//     //     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//     //     color: "white",
//     //     position: "relative",
//     //     overflow: "hidden",
//     //   }}
//     // >
//       <Box
//         sx={{
//           py: 8,
//           color: "white",
//           textAlign: "center",
//           background: "transparent",
//           backdropFilter: "blur(4px)",
//         }}
//       >
//                   <Typography
//                     variant="h4"
//                     sx={{
//                       mb: 4,
//                       fontWeight: "bold",
//                       textShadow: "1px 1px 6px rgba(0,0,0,0.8)",
//                     }}
//                   >
//                     Upcoming
//                   </Typography>
//           <Box
//     sx={{
//       position: "absolute",
//       top: 0,
//       left: 0,
//       width: "100%",
//       height: "100%",
//       backgroundImage: "url('/images/events/rockside.jpg')",
//       backgroundSize: "cover",
//       backgroundPosition: "center center",
//       backgroundAttachment: "fixed",
//       filter: "brightness(0.5)",
//       zIndex: -1,
//     }}
//   />
// <Container maxWidth="lg">
//         {/* Two Column Layout: Image Left, Logo/Title Right */}
// <Grid container spacing={4} alignItems="center" sx={{ mb: 6 }}>
//   {/* Left Column - Tour Image */}
//   <Grid item xs={12} md={6}>
//     <Box
//       component="img"
//       src="/images/FHR-KWE.png"
//       alt="Freedom Hour Radio Tour"
//       sx={{
//         width: "100%",
//         maxWidth: 500,
//         borderRadius: 3,
//         boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
//         display: "block",
//         mx: "auto",
//       }}
//     />
//     <center><strong>Hosted by KWE</strong></center>
//   </Grid>

//   {/* Right Column - Logo & Title */}
//   <Grid item xs={12} md={6}>
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         textAlign: "center",
//         height: "100%",
//         px: { xs: 2, md: 4 },
//       }}
//     >
//       {/* Logo */}
//       <Box sx={{ mb: 3 }}>
//         <Box
//           component="img"
//           src="/images/FreetimeRadioLogo.png"
//           alt="Word Sound Life"
//           sx={{
//             width: "80%",
//             maxWidth: 300,
//             objectFit: "contain",
//           }}
//         />
//       </Box>

//       {/* Title */}
//       <Typography
//         variant="h3"
//         sx={{
//           fontWeight: 700,
//           mb: 2,
//           fontSize: { xs: "1.75rem", md: "2.75rem" },
//           textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
//         }}
//       >
//         Road Show & Media Tour
//       </Typography>

//       {/* Subtitle */}
//       <Typography
//         variant="h6"
//         sx={{
//           opacity: 0.9,
//           fontSize: { xs: "1rem", md: "1.25rem" },
//           lineHeight: 1.6,
//           maxWidth: 480,
//         }}
//       >
//         Live-In-Studio performances with poets, singers, and players of instruments of the Music Is Healing Crew 
//       </Typography>
//     </Box>
//   </Grid>
//         </Grid>

//         {/* Call to Action Buttons Section */}
//         <Box sx={{ textAlign: "center", mt: 8 }}>
//           <Typography
//             variant="h5"
//             sx={{
//               mb: 4,
//               fontWeight: 600,
//             }}
//           >
//             Get Involved
//           </Typography>

//           {/* Buttons Grid */}
//           <Box
//             sx={{
//               display: "flex",
//               flexDirection: "column",
//               gap: 2,
//               maxWidth: 600,
//               mx: "auto",
//             }}
//           >
//             <Button
//               variant="contained"
//               size="large"
//               href="#subscribe"
//               sx={{
//                 py: 1.5,
//                 px: 4,
//                 fontWeight: 700,
//                 fontSize: "1.1rem",
//                 textTransform: "none",
//                 borderRadius: "50px",
//                 bgcolor: "white",
//                 color: "#667eea",
//                 border: "2px solid transparent",
//                 "&:hover": {
//                   bgcolor: "transparent",
//                   color: "white",
//                   border: "2px solid white",
//                   transform: "scale(1.02)",
//                 },
//                 transition: "all 0.2s ease",
//               }}
//             >
//               🔔 Get on the email list
//             </Button>

//             <Button
//               variant="outlined"
//               size="large"
//               href="https://docs.google.com/forms/d/e/1FAIpQLSc6ey758aVG3jtfekHWMsWHXHH9eAZs4kKivEf2JpCmtpIweQ/viewform?usp=sharing&ouid=100807907977782408965"
//               target="_blank"
//               rel="noopener noreferrer"
//               sx={{
//                 py: 1.5,
//                 px: 4,
//                 fontWeight: 700,
//                 fontSize: "1.1rem",
//                 textTransform: "none",
//                 borderRadius: "50px",
//                 color: "white",
//                 border: "2px solid white",
//                 "&:hover": {
//                   bgcolor: "white",
//                   color: "#667eea",
//                   transform: "scale(1.02)",
//                 },
//                 transition: "all 0.2s ease",
//               }}
//             >
//               🎪 Host at your venue
//             </Button>

//             <Button
//               variant="outlined"
//               size="large"
//               href="mailto:musicishealingus@gmail.com"
//               sx={{
//                 py: 1.5,
//                 px: 4,
//                 fontWeight: 700,
//                 fontSize: "1.1rem",
//                 textTransform: "none",
//                 borderRadius: "50px",
//                 color: "white",
//                 border: "2px solid white",
//                 "&:hover": {
//                   bgcolor: "white",
//                   color: "#667eea",
//                   transform: "scale(1.02)",
//                 },
//                 transition: "all 0.2s ease",
//               }}
//             >
//               📧 Contact us
//             </Button>
//           </Box>

//           {/* Additional CTA for cities not listed */}
//           <Box sx={{ mt: 6 }}>
//             <Typography
//               variant="h6"
//               sx={{
//                 mb: 2,
//                 fontWeight: 500,
//                 opacity: 0.9,
//               }}
//             >
//               Not in your area yet?
//             </Typography>
//             <Button
//               variant="outlined"
//               size="large"
//               href="https://airtable.com/appmdUAku7mfmhD9x/pagURHxA52v5OBGDN/form"
//               target="_blank"
//               rel="noopener noreferrer"
//               sx={{
//                 py: 1.5,
//                 px: 4,
//                 fontWeight: 700,
//                 fontSize: "1.1rem",
//                 textTransform: "none",
//                 borderRadius: "50px",
//                 color: "white",
//                 border: "2px solid white",
//                 "&:hover": {
//                   bgcolor: "white",
//                   color: "#667eea",
//                   transform: "scale(1.02)",
//                 },
//                 transition: "all 0.2s ease",
//               }}
//             >
//               📍 Bring Akwerius to your city
//             </Button>
//           </Box>
//         </Box>
//       </Container>

//       {/* Decorative Elements */}
//       <Box
//         sx={{
//           position: "absolute",
//           top: -50,
//           right: -50,
//           width: 300,
//           height: 300,
//           borderRadius: "50%",
//           background: "rgba(255, 255, 255, 0.1)",
//           filter: "blur(60px)",
//         }}
//       />
//       <Box
//         sx={{
//           position: "absolute",
//           bottom: -100,
//           left: -100,
//           width: 400,
//           height: 400,
//           borderRadius: "50%",
//           background: "rgba(255, 255, 255, 0.08)",
//           filter: "blur(80px)",
//         }}
//       />
//     </Box>
    
//   );
// }
